import {Test} from 'lib/test'
import * as React from 'react'
import {CircularProgressBar} from "app/Components/ProgressBar";
import { ISSSForm } from '.';

type PreviewProps = {
    test: Test
}

export class ISSSRawData extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.test && this.props.test.content ?
            <ISSSForm data={this.props.test.content.data} preview={true} /> : <CircularProgressBar/>
        }
    </>
}